// A dead session or lapsed subscription answers a stream fetch with a
// redirect fetch follows transparently: response.ok is then the 200
// sign-in page and renderStreamMessage applies nothing, silently (#3332).
// Promote the redirect to a full-page visit — the turbo:frame-missing
// policy in application.js — and return null so the caller stops.
export async function fetchStream(url, { method = "GET", body, signal } = {}) {
  const response = await fetch(url, {
    method,
    signal,
    headers: {
      Accept: "text/vnd.turbo-stream.html",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
    },
    body
  })

  if (response.redirected) {
    Turbo.visit(response.url)
    return null
  }

  return response
}
